import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const UnlinkIcon = React.memo(function UnlinkIcon(props: TUnlinkIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Unlink" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.6745 15.8989L11.581 14.8054L9.59348 16.7929C8.43762 17.9488 6.48684 18.0712 5.21067 16.7929C3.93235 15.5146 4.05481 13.5659 5.21067 12.4101L7.19817 10.4226L6.10032 9.32473L4.11282 11.3122C2.29524 13.1298 2.29524 16.071 4.11282 17.8865C5.9304 19.7019 8.87161 19.704 10.687 17.8865L12.6745 15.8989ZM11.3144 4.11282L9.32495 6.10054L10.4204 7.19602L12.4079 5.20852C13.5638 4.05266 15.5146 3.9302 16.7907 5.20852C18.0691 6.48684 17.9466 8.43547 16.7907 9.59133L14.8032 11.5788L15.9011 12.6767L17.8886 10.6892C19.704 8.87161 19.704 5.9304 17.8886 4.11282C16.071 2.29524 13.1298 2.29524 11.3144 4.11282ZM5.24076 4.13767C5.08455 3.98146 4.83128 3.98146 4.67507 4.13767L4.13767 4.67507C3.98146 4.83128 3.98146 5.08455 4.13767 5.24076L16.9334 18.0365C17.0896 18.1927 17.3429 18.1927 17.4991 18.0365L18.0365 17.4991C18.1927 17.3429 18.1927 17.0896 18.0365 16.9334L5.24076 4.13767Z"
            />
        </IconBase>
    );
});

export default UnlinkIcon;

// #region Types

export type TUnlinkIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <UnlinkIcon /> : { ...IconBaseExample, render: UnlinkIcon };

// #endregion
